import type { IconProps } from '../types/IconProps.ts';
export const MicVintage: IconProps = {
    name: 'MicVintage',
    children: [
        `<path d="M9 12a3 3 0 1 0 6 0V5a3 3 0 1 0-6 0m0 7V8.5M9 12h2M9 5v3.5M9 5h2M9 8.5h2M5 10v2a7 7 0 0 0 7 7m0 0a7 7 0 0 0 7-7v-2m-7 9v3" />`,
    ]
};